import { PLATFORM } from "byzantine";

import type { IPlatform } from "byzantine";

const webPlatform: IPlatform = {
  get: () => PLATFORM.web,
};

export default webPlatform;
